module.exports = __webpack_public_path__ + "static/media/sponsorships-graphic.c3605e55.png";